module.exports = __webpack_public_path__ + "img/home.c3e64520.png";